import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center bg-black px-6 overflow-hidden" data-id="element-98">
      {/* Cinematic Background */}
      <div className="absolute inset-0 z-0" data-id="element-99">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat animate-[zoom_20s_infinite_alternate]" style={{
        backgroundImage: "url('https://images.pexels.com/photos/2544829/pexels-photo-2544829.jpeg?auto=compress&cs=tinysrgb&w=1600')",
        transform: 'scale(1.1)'
      }} data-id="element-100" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80" data-id="element-101" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto text-center" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} className="mb-8 flex flex-col items-center" data-id="element-103">
          <span className="text-[#c9a961] text-[15px] md:text-[17px] font-medium tracking-[0.2em] uppercase mb-4" data-id="element-104">
            Premium Entertainment & Luxury Hospitality
          </span>
          <div className="w-16 h-[1px] bg-[#c9a961]/60" data-id="element-105" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="font-display text-white text-[56px] md:text-[80px] lg:text-[100px] font-medium leading-[1.05] tracking-tight mb-8" data-id="element-106">
          Experience Premium.
          <br data-id="element-107" />
          <span className="text-[#c9a961] italic" data-id="element-108">Taste Excellence.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-white/80 text-[19px] md:text-[22px] font-light leading-relaxed max-w-3xl mx-auto mb-12" data-id="element-109">
          Discover our diverse portfolio spanning premium film production and
          exceptional hospitality venues across Thailand.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="flex flex-col sm:flex-row gap-6 justify-center items-center" data-id="element-110">
          <a href="#businesses" className="inline-flex items-center px-10 py-4 bg-[#c9a961] text-black font-medium text-[15px] tracking-wide uppercase rounded-sm hover:bg-[#d4b872] hover:shadow-[0_0_30px_rgba(201,169,97,0.3)] transition-all duration-300 min-w-[220px] justify-center" data-id="element-111">
            Explore Portfolio
          </a>
          <a href="#contact" className="inline-flex items-center px-10 py-4 text-white font-medium text-[15px] tracking-wide uppercase rounded-sm border border-white/30 hover:border-[#c9a961] hover:text-[#c9a961] transition-all duration-300 min-w-[220px] justify-center backdrop-blur-sm" data-id="element-112">
            Get in Touch
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2" data-id="element-113">
        <span className="text-white/40 text-[10px] uppercase tracking-widest" data-id="element-114">
          Scroll
        </span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-[#c9a961] to-transparent" data-id="element-115" />
      </motion.div>
    </section>;
}